import { resolveSiteLinks, resolveTurnstileSiteKey } from '@kkf/design'

/**
 * The other three KKF apps, by absolute URL.
 *
 * `import.meta.env` is read here rather than inside the design system: `import.meta` is a
 * bundler-specific global, and `resolveSiteLinks` has to stay importable from React Native
 * when `app_mobile` arrives. Defaults are the production hosts, so a build with no `.env`
 * is a correct production build — see `.env.example`.
 */
export const LINKS = resolveSiteLinks(import.meta.env)

/**
 * Cloudflare Turnstile's site key.
 *
 * The public half of the pair — it is meant to be in the bundle, which is why it carries
 * the `VITE_` prefix like every other variable here. The secret half lives in `app_api`'s
 * `.env.secrets` and never reaches a browser.
 *
 * **Empty is a valid value, and it is the value today.** There is no Turnstile account yet,
 * so an unset key renders no widget and leaves the form working. The server's half matches:
 * `app_api` treats a missing token as a failure **only when it has a secret configured**, so
 * an unset key cannot accidentally refuse every submission.
 *
 * Read through `@kkf/design` rather than from `import.meta.env` here, for the reason
 * `resolveSiteLinks` is: one resolver for five apps, and one that stays importable from
 * React Native. The variable is in all five `.env.example` files and belongs in all five
 * Cloudflare Pages projects — it was in this app's and unread until 2026-09-21.
 */
export const TURNSTILE_SITE_KEY = resolveTurnstileSiteKey(import.meta.env)
